var PruebaComponent = /** @class */ (function () {
    function PruebaComponent() {
    }
    return PruebaComponent;
}());
export { PruebaComponent };
